import React from 'react';
import MessengerCustomerChat from 'react-messenger-customer-chat';
 
function Messenger() {
  const pageId = process.env.REACT_APP_CHATBOT_PAGEID;
  const appId = process.env.REACT_APP_CHATBOT_APPID;
  return (
    <div>
      <MessengerCustomerChat
        pageId={pageId}
        appId={appId}
      />
    </div>
  )
}
export default Messenger;